import { useEffect, useState } from "react";
//import "./styles.css";
import { Form, Button } from "react-bootstrap";

import "./plan.css";
import useFormValidation from "../../hooks/useFormValidator";
import { signUp } from "../../axios/signUp.axios";
import { useSelector, useDispatch } from "react-redux";
import { setTempUser } from "../../actions/signUp.actions";
import { NotificationContainer } from "react-notifications";
import { Link } from "react-router-dom";
const SignUp = (props) => {
  // const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const code = useSelector((state) => state.changeStep.affiliate);

  const [input, setInput] = useState({
    email: "",
    password: "",
    affiliate: "",
  });

  const [validationReport, validate] = useFormValidation();

  const change = async (wizard) => {
    if (
      validationReport.email &&
      validationReport.email.isValid &&
      validationReport.password &&
      validationReport.password.isValid
    ) {
      input.user_type = props.user_type ? props.user_type : "individual";

      props.loader(true);
      await signUp(input)
        .then((response) => {
          // console.log(response,"res")
          dispatch(setTempUser(response.data.data));
          props.changeWizard(wizard);
          props.loader(false);
        })
        .catch((err) => {
          //    alert(err.response.data.message)
          props.notify(err.response.data.message, false);
          props.loader(false);
        });
    } else {
    }
  };

  const handleChange = (event) => {
    let rules = JSON.parse(event.target.dataset.rules);

    validate(event.target.value, rules, event.target.name);
    if (event.target.name === "email") {
      setInput({
        ...input,
        [event.target.name]: event.target.value.toLowerCase(),
      });
    } else {
      setInput({ ...input, [event.target.name]: event.target.value });
    }
  };

  useEffect(() => {
    if (code)
      setInput({
        affiliate: code,
      });
  }, [code]);

  return (
    <div className="sign_up_partts">
      <NotificationContainer />
      <h3>1. Sign Up</h3>
      <p>
        To purchase this plan and use its benefits in the future, log in to your
        account or sign up.
      </p>

      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <div className="d-flex gap-4">
            <Form.Check
              type="radio"
              id="radio1"
              label="Individual User"
              name="user_type"
              value="individual"
              checked={props.user_type === "individual"}
              readOnly
            />
            <Form.Check
              type="radio"
              id="radio2"
              label="Advantage User"
              name="user_type"
              value="corporate"
              className="ml-5"
              checked={props.user_type === "corporate"}
              readOnly
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            value={input.email}
            type="email"
            name="email"
            placeholder="Enter email address"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              email: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.email && !validationReport.email.isValid ? (
            <small className="text-danger">
              {validationReport.email.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            value={input.password}
            name="password"
            type="password"
            placeholder="Password"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              password: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.password && !validationReport.password.isValid ? (
            <small className="text-danger">
              {validationReport.password.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>

        <div className="sign_submit flex-wrap justify-content-between align-items-center">
          <p className="mb-0">
            Already have an account? <Link to="/login">Login</Link>
          </p>
          {/* {show && <AdditionalInfo />} */}
          <Button
            variant="primary"
            type="button"
            onClick={() => {
              change("aInfo");
            }}
          >
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SignUp;
